import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import {OrganisationsService} from '../services/core/organisations.service';
import {AuthService} from '../services/core/auth.service';

@Injectable({
  providedIn: 'root'
})
export class LoginGuard {

  /**
   *
   * @param router
   * @param authService
   */
  constructor(private router: Router,
              private authService: AuthService) {
  }

  /**
   *
   * @param route
   * @param state
   */
  public async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    const organisation = OrganisationsService.getOrganisation();
    if(!organisation) {
      return this.router.createUrlTree(['/organisations']);
    }
    else if(this.authService.isLoginLocked) {
      return this.router.createUrlTree(['/tabs/employee']);
    }

    return !this.authService.isLoginLocked;
  }
  
}
